var ProductFeed = {
    selector : $('.js-productfeed__single'),
    modal : $('.js-productfeed-modal'),
    modalTitle : $('.js-productfeed-modal__title'),
    modalImage : $('.js-productfeed-modal__image'),
    modalDescription : $('.js-productfeed-modal__description'),
    modalInformation : $('.js-productfeed-modal__information'),
    modalSize : $('.js-productfeed-modal__size'),
	modalPrice : $('.js-productfeed-modal__price'),
	modalKickback : $('.js-productfeed-modal__kickback'),

    init : function () {
        if (ProductFeed.selector.length) {
            ProductFeed.selector.on('click', function () {
                var data = ProductFeed.getModalData($(this));
                ProductFeed.setModalData(data);
                ProductFeed.triggerModal();
            });

            ProductFeed.initSlider();
        }
    },

    getModalData : function ($this) {
        var data = {
            id : $this.data('id'),
            code : $this.data('code'),
            name : $this.data('name'),
			price : $this.data('price'),
			kickback : $this.data('kickback'),
            notis : $this.data('notis'),
            locname : $this.data('locname'),
            cat_id : $this.data('cat_id'),
            unit : $this.data('unit'),
            image : $this.data('image_large'),
            artstatus : $this.data('artstatus'),
            artstock : $this.data('artstock'),
            description : $this.data('description'),
            size : $this.data('size'),
        }

        return data;
    },

    setModalData : function (data) {
        ProductFeed.modalInformation.html('');

        if (data.name) {
            ProductFeed.modalTitle.html(data.name);
        } else {
            ProductFeed.modalTitle.html('');
        }

        if (data.image) {
            ProductFeed.modalImage.attr('src', data.image);
        } else {
            ProductFeed.modalImage.html('');
        }

		if (data.price) {
			ProductFeed.modalPrice.html('<span style="font-size:1.8em">' + data.price + ' kr</span>');
		} else {
			ProductFeed.modalPrice.html('');
		}
		
		if (data.kickback) {
			ProductFeed.modalKickback.html('<i style="color:#888;">Klassen/laget får ' + data.kickback + ' kronor per paket</i>');
		} else {
			ProductFeed.modalKickback.html('');
		}
		
        if (data.description) {
            ProductFeed.modalDescription.html(data.description.replace(/\n/g, '<br />'));
        } else {
            ProductFeed.modalDescription.html('');
        }

        if (data.code) {
            ProductFeed.modalInformation.append('<div class="code"><span><strong>Art.nr</strong></span><p> ' + data.code + '</p></div>');
        }

        if (data.size && data.size.length > 0) {
            ProductFeed.modalInformation.append('<div class="sizes"><span><strong>Storlekar</strong></span><p> ' + data.size + '</p></div>');

            var sizes = data.size.split(',');
            ProductFeed.modalSize.html('');
            sizes.forEach((size) => {
                ProductFeed.modalSize.append('<span>' + size + '</span>');
            });
        } else {
            ProductFeed.modalSize.html('');
        }
    },

    triggerModal : function () {
        ProductFeed.modal.modal('show');
    },

    initSlider : function () {
        const slider = document.querySelector('.js-productfeed__categories');
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
    },
}
export default ProductFeed;



// WEBPACK FOOTER //
// ./scripts/modules/productfeed.js